import { $config } from "../conf";

class StaticReqMapping {
  onOff = true; // 是否开启静态化
  apiCacheUrl = $config.api.gateway.JsonUrl + "/"; // 静态地址域名,
  format = ".json"; // 静态地址文件格式
  prefix = "$$"; // 正则前缀
  suffix = "@@"; // 正则后缀
  rules = {};

  // 拼接并返回静态请求地址
  getStaticUrl(url, params) {
    var _this = this; // this === window.staticReqMapping
    var staticUrl = "";
    /**
     * 不是以 / 开头的url补全 / （注意：配置中的地址必须统一以 / 开头
     * 主要是为了兼容webinar-live-template模板，因为其中的请求url都不是以 / 开头的
     * */
    if (url.indexOf("/") !== 0) {
      url = "/" + url;
    }
    if (_this.onOff && _this.rules[url]) {
      // console.log("<====================================================");
      // console.log("请求url:", url);
      // console.log('请求参数data:', params);
      // console.log('url对应的静态化配置信息:', _this.rules[url]);
      var staticInfo = _this.rules[url],
        prefix = _this.prefix,
        suffix = _this.suffix;
      // 如果url对应多个静态地址(在不同模块中调用不同的静态地址，例如报名表单、问卷、投票、文件)
      // staticUrl = !staticInfo.multiple ? staticInfo.staticUrl
      //     : (params['__module__'] && staticInfo.staticUrl[params['__module__']]) ? staticInfo.staticUrl[params['__module__']] : staticInfo.staticUrl.def;
      if (staticInfo.multiple) {
        var __module__ = params["__module__"],
          __typeArr__ = params["__typeArr__"];
        if (__module__) {
          // 是否按模块区分静态地址
          if (
            __typeArr__ &&
            typeof staticInfo.staticUrl[__module__] === "object"
          ) {
            // 是否存在多级
            switch (Object.prototype.toString.apply(__typeArr__)) {
              case "[object String]":
                staticUrl = staticInfo.staticUrl[__module__][__typeArr__];
                break;
              case "[object Array]":
                staticUrl = this.findUrl(
                  staticInfo.staticUrl[__module__],
                  __typeArr__,
                  0
                );
                break;
              default:
                break;
            }
          } else {
            staticUrl = staticInfo.staticUrl[__module__];
          }
        } else {
          // 不分模块
          if (__typeArr__ && typeof staticInfo.staticUrl.def === "object") {
            // 是否存在多级
            switch (Object.prototype.toString.apply(__typeArr__)) {
              case "[object String]":
                staticUrl = staticInfo.staticUrl.def[__typeArr__];
                break;
              case "[object Array]":
                staticUrl = this.findUrl(
                  staticInfo.staticUrl.def,
                  __typeArr__,
                  0
                );
                break;
              default:
                break;
            }
          } else {
            staticUrl = staticInfo.staticUrl.def;
          }
        }
      } else {
        staticUrl = staticInfo.staticUrl;
      }
      if (staticUrl) {
        staticInfo.regList.forEach(function (reg) {
          // console.log(staticUrl);
          // console.log(typeof staticUrl == "string");
          if (
            typeof staticUrl == "string" &&
            staticUrl.indexOf(prefix + reg + suffix) > -1
          ) {
            // console.log('替换标识:', prefix + reg + suffix);
            // console.log('替换内容:', '' + params[reg]);
            staticUrl = staticUrl.replace(
              prefix + reg + suffix,
              "" + params[reg]
            );
          }
        });
      } else {
        // 读取staticInfo.staticUrl[__module__]等属性时，有可能使staticUrl赋值为undefined等其它空值，需要置为空字符串，防止返回其它空值
        staticUrl = "";
      }
      // console.log("静态请求地址", staticUrl);
      // console.log("====================================================>");
    }
    return staticUrl;
  }

  // 如果存在多级，按照typeArr查找对应的staticUrl
  findUrl(map, typeArr, index) {
    if (typeArr[index + 1]) {
      return this.findUrl(map[typeArr[index]], typeArr, index + 1);
    }
    return map[typeArr[index]];
  }
}

const mapping = new StaticReqMapping();

mapping.defParams = {
  __module__: "",
  __objId__: "",
  isRefresh: false,
};

// 下面开始构建静态匹配规则
/**
 * 相关接口：
 * api/webinar/get
 * api/customform/get
 * api/questionnaire/get
 * poll/get
 * dic/params/getTree
 * file/getList
 * member/form/GetForNewForm
 * template/template/getConfig
 * api/member/form/get
 * member/schema/orderUnique
 */
// 获取会议信息
mapping.rules["/api/webinar/get"] = {
  staticUrl:
    mapping.apiCacheUrl +
    mapping.prefix +
    "tenantId" +
    mapping.suffix +
    "/webinar/" +
    mapping.prefix +
    "webinarId" +
    mapping.suffix +
    "/info" +
    mapping.format,
  regList: ["tenantId", "webinarId"],
};
// 获取自定义表单(报名表单)的地址（新） http://static.smarket.net.cn/租户ID/customform/表单ID.json
mapping.rules["/api/customform/get"] = {
  staticUrl: {
    2:
      mapping.apiCacheUrl +
      mapping.prefix +
      "tenantId" +
      mapping.suffix +
      "/webinar/" +
      mapping.prefix +
      "__objId__" +
      mapping.suffix +
      "/signup/" +
      mapping.prefix +
      "customFormId" +
      mapping.suffix +
      mapping.format,
    3:
      mapping.apiCacheUrl +
      mapping.prefix +
      "tenantId" +
      mapping.suffix +
      "/seminar/" +
      mapping.prefix +
      "__objId__" +
      mapping.suffix +
      "/signup/" +
      mapping.prefix +
      "customFormId" +
      mapping.suffix +
      mapping.format,
    def:
      mapping.apiCacheUrl +
      mapping.prefix +
      "tenantId" +
      mapping.suffix +
      "/customform/" +
      mapping.prefix +
      "customFormId" +
      mapping.suffix +
      mapping.format,
  },
  regList: ["tenantId", "__objId__", "customFormId"],
  multiple: true,
};
// 获取问卷（新） http://static.smarket.net.cn/租户ID/questionnaire/问卷ID.json
mapping.rules["/api/questionnaire/get"] = {
  staticUrl: {
    2:
      mapping.apiCacheUrl +
      mapping.prefix +
      "tenantId" +
      mapping.suffix +
      "/webinar/" +
      mapping.prefix +
      "__objId__" +
      mapping.suffix +
      "/questionnaire/" +
      mapping.prefix +
      "questionnaireId" +
      mapping.suffix +
      mapping.format,
    3:
      mapping.apiCacheUrl +
      mapping.prefix +
      "tenantId" +
      mapping.suffix +
      "/seminar/" +
      mapping.prefix +
      "__objId__" +
      mapping.suffix +
      "/questionnaire/" +
      mapping.prefix +
      "questionnaireId" +
      mapping.suffix +
      mapping.format,
    def:
      mapping.apiCacheUrl +
      mapping.prefix +
      "tenantId" +
      mapping.suffix +
      "/questionnaire/" +
      mapping.prefix +
      "questionnaireId" +
      mapping.suffix +
      mapping.format,
  },
  regList: ["tenantId", "__objId__", "questionnaireId"],
  multiple: true,
};
// 获取投票信息 http://static.smarket.net.cn/租户ID/poll/投票ID.json
mapping.rules["/poll/get"] = {
  staticUrl: {
    2:
      mapping.apiCacheUrl +
      mapping.prefix +
      "tenantId" +
      mapping.suffix +
      "/webinar/" +
      mapping.prefix +
      "__objId__" +
      mapping.suffix +
      "/poll/" +
      mapping.prefix +
      "pollId" +
      mapping.suffix +
      mapping.format,
    3:
      mapping.apiCacheUrl +
      mapping.prefix +
      "tenantId" +
      mapping.suffix +
      "/seminar/" +
      mapping.prefix +
      "__objId__" +
      mapping.suffix +
      "/poll/" +
      mapping.prefix +
      "pollId" +
      mapping.suffix +
      mapping.format,
    def:
      mapping.apiCacheUrl +
      mapping.prefix +
      "tenantId" +
      mapping.suffix +
      "/poll/" +
      mapping.prefix +
      "pollId" +
      mapping.suffix +
      mapping.format,
  },
  regList: ["tenantId", "__objId__", "pollId"],
  multiple: true,
};
// 字典表 http://static.smarket.net.cn/租户ID/dic/list/字典ID.json
mapping.rules["/dic/params/getTree"] = {
  staticUrl:
    mapping.apiCacheUrl +
    mapping.prefix +
    "tenantId" +
    mapping.suffix +
    "/dic/list/" +
    mapping.prefix +
    "dicId" +
    mapping.suffix +
    mapping.format,
  regList: ["tenantId", "dicId"],
};
// 文件列表 http://uat-cache-sino.oss-cn-beijing.aliyuncs.com/租户ID/webinar/会议ID/file/list/文件夹ID.json
mapping.rules["/file/getList"] = {
  staticUrl: {
    2: {
      file:
        mapping.apiCacheUrl +
        mapping.prefix +
        "tenantId" +
        mapping.suffix +
        "/webinar/" +
        mapping.prefix +
        "__objId__" +
        mapping.suffix +
        "/file/list/info/" +
        mapping.prefix +
        "fileIds" +
        mapping.suffix +
        mapping.format,
      folder:
        mapping.apiCacheUrl +
        mapping.prefix +
        "tenantId" +
        mapping.suffix +
        "/webinar/" +
        mapping.prefix +
        "__objId__" +
        mapping.suffix +
        "/file/folder/info/" +
        mapping.prefix +
        "folderId" +
        mapping.suffix +
        mapping.format,
    },
    3: {
      file:
        mapping.apiCacheUrl +
        mapping.prefix +
        "tenantId" +
        mapping.suffix +
        "/seminar/" +
        mapping.prefix +
        "__objId__" +
        mapping.suffix +
        "/file/list/info/" +
        mapping.prefix +
        "fileIds" +
        mapping.suffix +
        mapping.format,
      folder:
        mapping.apiCacheUrl +
        mapping.prefix +
        "tenantId" +
        mapping.suffix +
        "/seminar/" +
        mapping.prefix +
        "__objId__" +
        mapping.suffix +
        "/file/folder/info/" +
        mapping.prefix +
        "folderId" +
        mapping.suffix +
        mapping.format,
    },
    def: {
      file:
        mapping.apiCacheUrl +
        mapping.prefix +
        "tenantId" +
        mapping.suffix +
        "/file/list/info/" +
        mapping.prefix +
        "fileIds" +
        mapping.suffix +
        mapping.format,
      folder:
        mapping.apiCacheUrl +
        mapping.prefix +
        "tenantId" +
        mapping.suffix +
        "/file/folder/info/" +
        mapping.prefix +
        "folderId" +
        mapping.suffix +
        mapping.format,
    },
    // '2': mapping.apiCacheUrl + mapping.prefix + 'tenantId' + mapping.suffix + '/webinar/' + mapping.prefix + '__objId__' + mapping.suffix + '/file/list/' + mapping.prefix + 'folderId' + mapping.suffix + mapping.format,
    // '3': mapping.apiCacheUrl + mapping.prefix + 'tenantId' + mapping.suffix + '/seminar/' + mapping.prefix + '__objId__' + mapping.suffix + '/file/list/' + mapping.prefix + 'folderId' + mapping.suffix + mapping.format,
    // 'def': mapping.apiCacheUrl + mapping.prefix + 'tenantId' + mapping.suffix + '/file/list/' + mapping.prefix + 'folderId' + mapping.suffix + mapping.format
  },
  regList: ["tenantId", "__objId__", "fileIds", "folderId"],
  multiple: true,
};
// 获取登录注册的地址
mapping.rules["/member/form/GetForNewForm"] = {
  staticUrl:
    mapping.apiCacheUrl +
    mapping.prefix +
    "tenantId" +
    mapping.suffix +
    "/member/form/" +
    mapping.prefix +
    "memberFormId" +
    mapping.suffix +
    "/infos" +
    mapping.format,
  regList: ["tenantId", "memberFormId"],
};
// 获取注册表单信息
mapping.rules["/api/member/form/get"] = {
  staticUrl:
    mapping.apiCacheUrl +
    mapping.prefix +
    "tenantId" +
    mapping.suffix +
    "/member/form/" +
    mapping.prefix +
    "formId" +
    mapping.suffix +
    "/info" +
    mapping.format,
  regList: ["tenantId", "formId"],
};
// 忘记密码 - 表单信息
mapping.rules["/member/schema/orderUnique"] = {
  staticUrl:
    mapping.apiCacheUrl +
    mapping.prefix +
    "tenantId" +
    mapping.suffix +
    "/member/form/" +
    mapping.prefix +
    "memberFormId" +
    mapping.suffix +
    "/fields" +
    mapping.format,
  regList: ["tenantId", "memberFormId"],
};
// 获取模板信息 http://static.smarket.net.cn/1038/template/1504581.json
mapping.rules["/template/template/getConfig"] = {
  staticUrl:
    mapping.apiCacheUrl +
    mapping.prefix +
    "tenantId" +
    mapping.suffix +
    "/template/" +
    mapping.prefix +
    "configId" +
    mapping.suffix +
    mapping.format,
  regList: ["configId", "tenantId"],
};
// 获取点播信息 http://static.smarket.net.cn/1038/webinar/demand/62727/info.json
mapping.rules["/api/webinar/demand/get"] = {
  staticUrl:
    mapping.apiCacheUrl +
    mapping.prefix +
    "tenantId" +
    mapping.suffix +
    "/webinar/demand/" +
    mapping.prefix +
    "webinarId" +
    mapping.suffix +
    "/info" +
    mapping.format,
  regList: ["tenantId", "webinarId"],
};

// 获取某个栏目下的栏目列表,包含子级栏目
mapping.rules["/api/article/category/sub/query"] = {
  staticUrl:
    mapping.apiCacheUrl +
    mapping.prefix +
    "tenantId" +
    mapping.suffix +
    "/article/category/" +
    mapping.prefix +
    "articleCategoryId" +
    mapping.suffix +
    mapping.format,
  regList: ["tenantId", "articleCategoryId"],
};

export { mapping as staticReqMapping };
